import React, { useState, useEffect, useRef } from 'react';
import './styles.css'; // Importiere die CSS-Datei

// Präsentations-Screen
const Screen = ({performingItem, upcomingItem, resultItem, tournamentItem, textOnScreen, showAnimation}) => {

    const headSection = (
      <head>
        <title>${tournamentItem.name}</title>
          <link
            href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0-alpha1/dist/css/bootstrap.min.css"
            rel="stylesheet"
          />
          <link rel="stylesheet" href="./components/styles.css"/>
          <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@400;600;700&display=swap" rel="stylesheet"/>
        <style>
          {`
          @font-face {
  font-family: 'Poppins';
  src: url('./fonts/Poppins-Regular.ttf') format('ttf'),
       url('./fonts/Poppins-Regular.ttf') format('ttf');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'Poppins';
  src: url('./fonts/Poppins-Bold.ttf') format('ttf'),
       url('./fonts/Poppins-Bold.ttf') format('ttf');
  font-weight: bold;
  font-style: normal;
}
           :root {
              --color1: #590B54;
              --color2: #000;
              --background: #F2F2F2;
              --textColor: #000;
            }
            body {
              background-color: var(--background);
              color: var(--textColor);
              font-family: 'Poppins';
              height: 100%;
              margin: 365 218 0 189;
            }
  
            .h1-title {
              text-align: center;
              font-size: 1.7rem;
              margin-bottom: 30px;
              font-weight: bold;
              color: var(--color1);
              padding-top: 5%;
            }
            
            h1 {
              text-align: center;
              font-size: 1.7rem;
              margin-bottom: 30px;
              font-weight: bold;
              color: var(--textColor);
            }            
  
            .card {
              margin: 10px auto;
              width: 80%;
              box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
            }
  
            .card-body {
              background-color: #ffffff;
              color: var(--textColor);
              border-radius: 10px;
              text-align: center;
            }
  
            .card-title {
              font-weight: bold;   
              color: var(--color2);
           
            }
  
            .card-subtitle {
              font-size: 0.9rem;
              color: var(--textColor);
              margin-top: 5px;
            }
  
            .card-text {
              font-size: 0.8rem;
              color: var(--textColor);
            }
            .main-card {
              background-color: #ecf0f1;
              border: 5px solid var(--color1);
              min-Height: 160px;
            }

/* Definiere die Uhrzeigersinn-Animation */
@keyframes glowing-border-clockwise {
  0% {
    border-top: 5px solid var(--color1); /* Oben leuchtet */
    border-right: 5px solid transparent;
    border-bottom: 5px solid transparent;
    border-left: 5px solid transparent;
  }
  25% {
    border-top: 5px solid transparent;
    border-right: 5px solid var(--color1); /* Rechts leuchtet */
    border-bottom: 5px solid transparent;
    border-left: 5px solid transparent;
  }
  50% {
    border-top: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 5px solid var(--color1); /* Unten leuchtet */
    border-left: 5px solid transparent;
  }
  75% {
    border-top: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 5px solid transparent;
    border-left: 5px solid var(--color1); /* Links leuchtet */
  }
  100% {
    border-top: 5px solid var(--color1); /* Wieder oben leuchtet */
    border-right: 5px solid transparent;
    border-bottom: 5px solid transparent;
    border-left: 5px solid transparent;
  }
}

/* Anwenden der Animation */
.glowing-border-clockwise {
  animation: glowing-border-clockwise 2s ease-in-out;
}
            .upcoming-card {
              background-color: #ecf0f1;
              border-left: 5px solid var(--color1);
              min-Height: 50px;
            }

            .result-card {
              background-color: #ecf0f1;
              min-Height: 50px;
            }
  
            .result-card .card-title {
              color: var(--color2);
            }
  
            .result-card .card-body {
              text-align: left;
              padding: 10px 20px 0 20px;  
            }
  
            .footer {
              text-align: center;
              margin-top: 30px;
              font-size: 0.9rem;
              color: #95a5a6;
              position: sticky;
              width: 100%;
              bottom: 1%;
            }
          `}
        </style>
      </head>
    );

    const footerContent = (
      <div className="footer">
        <p>&copy; RG Tournament by cadaconcepts (2024)</p>
      </div>
    );

    const mainCardContent = (
      <div className={showAnimation ? "card main-card glowing-border-clockwise" : "card main-card"}>
        <div className="card-body">
          <h1 className="card-title">{!textOnScreen.showOnScreen ? performingItem.nr : ''}</h1>
          <h2 className="card-title">{!textOnScreen.showOnScreen ? performingItem.name : textOnScreen.title}</h2>
          <h4 className="card-subtitle mb-2">
            {!textOnScreen.showOnScreen ? performingItem.club : textOnScreen.text}
          </h4>
          <h6 className="card-subtitle mb-2 ">
          {!textOnScreen.showOnScreen ? (<span>{performingItem.app} | {performingItem.category}</span>) : ''}
                    </h6>
        </div>
      </div>
    );

    const upcomingCardContent = (
      <div className="card upcoming-card" style={upcomingItem.name ? {}: {borderLeft: 'none'}} >
        <div className="card-body" style={{padding: '5px'}}>
          <p className="card-text" >
            {upcomingItem.name ? (<span><i>Upcoming</i><br/> {upcomingItem.name} ({upcomingItem.app} | {upcomingItem.category})</span>) : null}
          </p>
        </div>
      </div>
    );
    
    const resultCardContent = resultItem != null ? (
      <div className="card result-card">
        <div className="card-body">
          {/* <h6 className="card-subtitle">Results</h6> */}
          <div className="d-flex justify-content-between align-items-center">
            <h6 className="card-subtitle mb-2 ">
              {/* {resultItem.name} ({resultItem.id} | {resultItem.app} | {resultItem.category}) */}
              {resultItem.name}
            </h6>
            <h6 className="card-subtitle mb-2  text-end">
              {resultItem.score}
            </h6>
          </div>
        </div>
      </div>
    ) : (      <div style={{ minHeight: '100px' }}/>);

    // Hier werden die Teile zu einem vollständigen Layout zusammengesetzt
    return (
      <html>
        {headSection}
        <body>
          <h1 className='h1 h1-title'>{tournamentItem.name}</h1>
          {/* <h1 className='h1 h1-title'>{performingItem.name}</h1> */}
          {mainCardContent}
          {upcomingCardContent}
          {resultCardContent}
          {footerContent}
        </body>
      </html>
    );
  }; 

export default Screen;
